import { getAIHook } from '@openclassrooms/data-connect-web/utils';

const useEnhanceJobDescription = getAIHook({
  promptCode: 'enhance-job-description',
  serverName: 'ai-api-user',
});

export default useEnhanceJobDescription;
